<template>
  <div class="introduction">
    <img class="top-img" src="/images/introduction-top-img.png" alt="">
    <div class="main">
      <div class="wrapper">
        <div class="content">
          <img class="greetings-img" src="/images/introduction-greetings.png" alt="">
          <div class="tips">
            <p class="text"><span class="label"></span>完成评测后，会给出孩子科学的发展报告</p>
            <p><span class="label"></span>智伴优学体系会根据您孩子的特点，为您推荐专属的365天成长计划，帮助您的孩子习得0-12岁学习与生活必备的品格和关键能力</p>
          </div>
        </div>
      </div>
    </div>
    <button class="btn" @click="toNext">开始评测</button>
    <div class="bottom-img"></div>
  </div>
</template>
<script>
import { wechatShareEvaluationPage } from "@/mixins/wechatShare.js";
import { mapGetters } from "vuex";
export default {
  mixins: [wechatShareEvaluationPage],
  data() {
    return {
      timeOutEvent: 0
    };
  },
  computed: {
    ...mapGetters({
      isNative: "externalInterface/isNative",
      isAuth: "auth/isAuth"
    })
  },
  methods: {
    toNext() {
      if (this.isNative && !this.isAuth) {
        this.$store.dispatch("externalInterface/navigateTo", {
          name: "login",
          params: {
            redirect: `${process.env.VUE_APP_SHARE_URL}/index.html#/evaluation/kid-info`
          }
        });
      } else {
        this.$router.push("/evaluation/kid-info");
      }
    }
  }
};
</script>
<style scoped>
.introduction {
  width: 100vw;
  height: 100vh;
  position: relative;
  font-size: 0;
}
.main {
  height: 100%;
  width: 100%;
  padding-bottom: 170px;
  padding-top: 201px;
}
.main::before,
.main::after {
  content: "";
  width: 19px;
  height: 100%;
  position: absolute;
  background-color: #469dff;
  top: 0;
}
.main::before {
  left: 0;
}
.main::after {
  right: 0;
}
.wrapper {
  width: 100%;
  height: 100%;
  padding: 0 19px;
}
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
  overflow: auto;
}
.greetings-img {
  width: 85px;
  height: 39px;
  margin-left: 13px;
}
.top-img {
  width: 100%;
  height: 190px;
  position: absolute;
  z-index: 2;
}
.tips {
  color: #244352;
  font-size: 13px;
  line-height: 26px;
  padding: 0 40px;
}
.tips .text{
  margin-bottom: 8px;
}
.label{
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background:rgba(255,190,52,1);
  margin-right: 7px;
}
.btn {
  width: 240px;
  height: 48px;
  background: rgba(70, 157, 255, 1);
  box-shadow: 0px 2px 12px rgba(70, 157, 255, 0.6);
  border-radius: 30px;
  color: #fff;
  font-size: 16px;
  position: absolute;
  left: 50%;
  bottom: 120px;
  transform: translateX(-50%);
}
.bottom-img {
  width: 100%;
  height: 126px;
  position: absolute;
  bottom: 0;
  background: url("/images/introduction-btm-img.png") no-repeat;
  background-size: 375px 126px;
}
</style>

